import { EventData } from 'hooks/useDataLayer';
import { Row, Column, Layout } from 'model/Form';
import FormsSharedFields from '../Forms/FormsSharedFields';
import { isHeader, isDescription, getColClass } from 'hooks/useForm';

export const Rows: React.FC<{
  layout?: Layout;
  formName?: string;
  icon: boolean;
  onChange: (value: any) => void;
  onUpdateDataLayer: (data: EventData) => void;
  onExecuteFormStartEvent: (data: EventData) => void;
}> = ({ layout, formName, icon, onChange, onUpdateDataLayer, onExecuteFormStartEvent }) => {
  return layout?.rows?.map((row: Row, i) => {
    if (isHeader(row)) {
      return (
        <div
          key={i}
          className="form-field-header d-flex flex-column flex-md-row align-items-md-center"
        >
          {icon && <i className="bi bi-star me-2" aria-hidden="true" />}

          <span className="h3">{row.cols[0].cells[0].element.name}</span>
        </div>
      );
    } else if (isDescription(row)) {
      return (
        <p key={i} className="form-field-list body-default text-grey">
          {row.cols[0].cells[0].element.name}
        </p>
      );
    }

    return row.cols.map(
      (col: Column) =>
        col.cells[0] && (
          <div
            key={col.cells[0].element.createdFromContactFieldId}
            className={`mb-3 ${getColClass(col.width)}`}
          >
            <FormsSharedFields
              element={col.cells[0].element}
              formName={formName}
              formType="eloqua"
              onChange={onChange}
              onUpdateDataLayer={onUpdateDataLayer}
              onExecuteFormStartEvent={onExecuteFormStartEvent}
            />
          </div>
        )
    );
  });
};
